var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.classButton,on:{"click":function($event){_vm.touch($event);}}},[_c('div',{class:_vm.classElem,style:({ left: _vm.x + 'px', top: _vm.y + 'px', height: _vm.d + 'px', width: _vm.d + 'px' })}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }